import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import UserUtils from 'utils/user-utils';
import dayjs from 'utils/dayjs-timezone';
import getUserLocation from '../utils/user-location';
import ReservationUtils from 'utils/reservation-utils';
import getReservationStatus from 'segment/utils/reservation-status';

export default function trackParkingPassPage({
    reservation,
    user,
    activeStatus,
    redemptionType,
}) {
    try {
        const now = dayjs();
        const {status} = user;
        const {
            starts,
            ends,
            timezone,
            reservationType,
            city,
            facility,
            rentalId,
            entryTimestamp,
            exitTimestamp,
            paymentStatus,
        } = reservation;
        const isMonthly =
            reservationType === ReservationUtils.RESERVATION_TYPES.MONTHLY;
        const reservationStatus = getReservationStatus({
            activeStatus,
            paymentStatus,
        });
        const properties = {
            city: city.slug,
            cannot_adjust_after_entry: !facility.allowUpdatingReservationAfterEntry,
            parking_spot_id: facility.id,
            parking_spot_name: facility.title,
            parking_type: reservationType,
            parking_pass_type: reservation.parkingPassType,
            redemption_type: redemptionType,
            rental_id: rentalId,
            rental_lead_time: starts.diff(now.tz(timezone), 'minutes'),
            rental_length: isMonthly ? null : ends.diff(starts, 'minutes'),
            reservation_status: reservationStatus,
            scanned_in_time: entryTimestamp,
            scanned_out_time: exitTimestamp,
            state: facility.state,
            user_logged_in: status === UserUtils.AUTH_STATE.USER,
            ...getUserLocation(),
        };

        SegmentUtils.page({
            name: 'Parking Pass',
            properties,
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Page Failed - trackParkingPassPage',
        });
    }
}
